import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
  ReportDesignItemCheck,
  ReportDesignItemCheckConfig
} from "src/app/modules/bootstrap/modules/report/report-design-item";

@Component({
  standalone: false,
  selector: "snt-report-designer-check",
  templateUrl: "report-designer-check.component.html",
  styles: `
    :host {
      display: flex;
      flex: 1;
    }
  `
})
export class ReportDesignerCheckComponent {
  formData: { text: string } = {
    text: ""
  };

  @Input()
  item: ReportDesignItemCheck | undefined;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Input()
  readonly: boolean = false;

  @Output()
  config: EventEmitter<ReportDesignItemCheckConfig> = new EventEmitter();

  onFieldDataChanged(): void {
    this.config.emit({
      ...this.item!.config,
      ...this.formData
    });
  }

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "check",
      config: {
        text: this.formData.text
      }
    };
  }
}
